import { StateCreator } from "zustand";
import { APILookupValue } from "@/services/api/types";

export interface LookupData {
  companyIndustries?: APILookupValue[];
  companySegments?: APILookupValue[];
  personJobFunctions?: APILookupValue[];
  leadTypes?: APILookupValue[];
  sources?: APILookupValue[];
}

export interface LookupSliceState {
  data: LookupData;
  setCompanyIndustries: (industries: APILookupValue[]) => void;
  setCompanySegments: (segments: APILookupValue[]) => void;
  setPersonJobFunctions: (jobFunctions: APILookupValue[]) => void;
  setLeadTypes: (types: APILookupValue[]) => void;
  setLeadSourceTypes: (sources: APILookupValue[]) => void;
  clearLookupData: () => void;
}

export const createLookupSlice: StateCreator<
  { lookup: LookupSliceState },
  [],
  [["zustand/immer", never]],
  LookupSliceState
> = (set) => ({
  data: {},

  setCompanyIndustries: (industries: APILookupValue[]) =>
    set((state) => ({
      lookup: {
        ...state.lookup,
        data: {
          ...state.lookup.data,
          companyIndustries: industries
        }
      }
    })),

  setCompanySegments: (segments: APILookupValue[]) =>
    set((state) => ({
      lookup: {
        ...state.lookup,
        data: {
          ...state.lookup.data,
          companySegments: segments
        }
      }
    })),

  setPersonJobFunctions: (jobFunctions: APILookupValue[]) =>
    set((state) => ({
      lookup: {
        ...state.lookup,
        data: {
          ...state.lookup.data,
          personJobFunctions: jobFunctions
        }
      }
    })),

  setLeadTypes: (types: APILookupValue[]) =>
    set((state) => ({
      lookup: {
        ...state.lookup,
        data: {
          ...state.lookup.data,
          leadTypes: types
        }
      }
    })),

  setLeadSourceTypes: (sources: APILookupValue[]) =>
    set((state) => ({
      lookup: {
        ...state.lookup,
        data: {
          ...state.lookup.data,
          sources
        }
      }
    })),

  clearLookupData: () =>
    set((state) => ({
      lookup: {
        ...state.lookup,
        data: {}
      }
    }))
});
